import { INotes } from '@modeso/types__aumico-lib-annualreport-be';
import { ITranslatorVisitor } from '../ITranslatorVisitor.interface';

export class Notes {
    constructor(public notes: INotes) {}

    public accept(visitor: ITranslatorVisitor) {
        visitor.visit(this);
    }
}
